import { FileCheck2, MapPin, Scale } from 'lucide-react';
import { BRAND } from '@chukua/common';
import { PoweredByChukua } from '../../../shared/features/organization/components/PoweredByChukua';
import { useOrganization } from '../../../shared/features/organization/components/OrganizationProvider';
import { TenantLogo } from '../../../shared/features/organization/components/TenantLogo';

const HIGHLIGHTS = [
  { icon: MapPin, text: 'Live tracking and geofence alerts' },
  { icon: FileCheck2, text: 'eTIMS invoices straight from delivered trips' },
  { icon: Scale, text: 'Owner statements that balance to the shilling' },
];

/** The dark brand half of the login screen. Dark in both colour modes: the dark palette's warm charcoal, via the fixed `panel` colours. */
export function LoginBrandPanel() {
  const { configured } = useOrganization();
  return (
    <aside className="relative hidden overflow-hidden bg-panel p-12 text-panel-fg lg:flex lg:flex-col lg:justify-between">
      <div
        aria-hidden
        className="absolute inset-0 bg-[linear-gradient(to_right,currentColor_1px,transparent_1px),linear-gradient(to_bottom,currentColor_1px,transparent_1px)] [mask-image:linear-gradient(to_bottom,black,transparent)] bg-[size:48px_48px] text-panel-fg/[0.04]"
      />
      <div aria-hidden className="absolute -top-40 -left-40 size-[36rem] rounded-full bg-primary/20 blur-3xl" />

      <div className="relative">
        <TenantLogo size="panel" surface="dark" />
      </div>

      <div className="relative max-w-md">
        <h2 className="text-4xl leading-tight font-semibold tracking-tight">Every trip, truck and shilling in one place.</h2>
        <ul className="mt-8 space-y-3">
          {HIGHLIGHTS.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-center gap-3 text-sm text-panel-fg/75">
              <span className="grid size-8 place-items-center rounded-lg bg-panel-fg/10 ring-1 ring-panel-fg/15">
                <Icon className="size-4" />
              </span>
              {text}
            </li>
          ))}
        </ul>
      </div>

      <div className="relative">{configured ? <PoweredByChukua surface="dark" /> : <p className="font-mono text-xs text-panel-fg/50">{BRAND.domain}</p>}</div>
    </aside>
  );
}
